import { render, staticRenderFns } from "./AbstractNPC.vue?vue&type=template&id=5248c314&"
import script from "./AbstractNPC.vue?vue&type=script&lang=js&"
export * from "./AbstractNPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports